import UltMeta, { Meta } from "./UltMeta/index";
// 安装推广佣金记录

class State extends UltMeta {
    ACTIVATED = new Meta(1, "已激活");
    INVALID = new Meta(2, "已失效");
}

export const STATE = new State();
